import categorias from './categorias';
import empresas from './empresas';
import powerUps from './power-ups';
import usuarios from './usuarios';
import configuracoes from './configuracoes';
import versionamentoBdgd from './versionamentoBdgd';
import tour from './tour';
import perfis from './perfis';

let children = [
  {
    name: 'Administração',
    path: '/administracao',
    component: () => import('@/views/administracao/Index.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      manager: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração' }
      ]
    }
  }
];

children = children.concat(
  categorias,
  empresas,
  powerUps,
  usuarios,
  configuracoes,
  versionamentoBdgd,
  tour,
  perfis
);

export default [{
  path: '/administracao',
  component: () => import('@/views/Index'),
  children
}];
